import $ from 'jquery';

const SmoothScroll = () => {
  $(document).on('click', '.js-scroll', function(e) {
    e.preventDefault();
    const href = $(this).attr('href');
    const target = $(href);
    const position = target.offset().top;
    const shift = -65;
    $('html, body').animate({
      scrollTop: position + shift,
    }, 500);
  });
}

export default SmoothScroll;
